import { v2 } from '@saucelabs/sl-module-builds';

export const NAMESPACE = 'builds-detail-vdc';

export const vdcBuildsDetailV2Types = v2.buildsDetail.types.createVDCTypes(NAMESPACE);
export const vdcBuildsListV2Types = v2.buildsList.types.createVDCTypes(NAMESPACE);
